import { createAction } from '../../utils/redux-helper';
import { deleteFromLocalStorage } from '../../utils/localStorage';
import * as ActionDefinitions from './actionDefinitions';

export const setAlertOptions = (config, clearData = false) => {
  if(clearData) {
    deleteFromLocalStorage('token');
    deleteFromLocalStorage('timestamp');
  }
  return createAction(ActionDefinitions.SET_ALERT_OPTIONS, config);
};

const timeout = 5000;
export const manageResponseAlerts = (isSuccessful = false, specificMessage = false, t) => dispatch => {
  const message = !specificMessage ? t('alert.error') : specificMessage;
  dispatch(
    setAlertOptions({ mode: 'result', data: { description: message, ok: isSuccessful } })
  );
  setTimeout(() => {
    dispatch(setAlertOptions({}));
  }, timeout
  );
};
